import EmptyResultsPlaceholder from './emptyResultsPlaceholder'

export default EmptyResultsPlaceholder
